export default __webpack_public_path__ + "static/media/icon_expert.f62d5c8b.svg";